"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var addressDisplay_1 = require("./addressDisplay");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var interpolate_1 = require("../../../utils/interpolate/interpolate");
var constants_1 = require("../../../constants");
var route_utils_1 = require("../../../route.utils");
var ROUTES = constants_1.default.ROUTES;
var page = require("page");
function handleClick(route) {
    var isFlow = route.isFlow || false, flowName = route.enter.flow || "", isBaseFlowInHistory = route.history && route.history.includes(ROUTES.ADDRESSES.FLOW_BASE);
    if (isFlow && !isBaseFlowInHistory) {
        route_utils_1.transitionOutHandler();
        page(constants_1.default.BASE_URI + "/flow-return/" + flowName);
    }
    else {
        page.back();
    }
}
function UpdateBillingMessage(_a) {
    var commonContent = _a.commonContent, addressContent = _a.addressContent, route = _a.route, addressData = _a.addressData, addressFpti = _a.addressFpti, isUpdate = _a.isUpdate;
    var removeAddressId = route.enter.params.id, addressAll = addressData.addresses, addressToRemove = addressAll.find(function (addr) { return addr.id === removeAddressId; });
    if (!removeAddressId || !addressToRemove) {
        return null;
    }
    return (React.createElement("div", { className: "generic-container fullHeight" },
        React.createElement("div", { className: "removeBilling-header" }, isUpdate ? (React.createElement(pp_react_1.Text, { size: "xl3" }, addressToRemove.cardList.length > 1
            ? addressContent.billing.cantEditHeaderMultiple
            : addressContent.billing.cantEditHeaderSingle)) : (React.createElement(pp_react_1.Text, { size: "xl3" }, addressContent.billing.cantRemoveHeader))),
        React.createElement(pp_react_1.Divider, { secondary: true }),
        React.createElement(addressDisplay_1.default, { className: "removeBilling-display", displayMetadata: addressToRemove.displayMetadata }),
        React.createElement(pp_react_1.Divider, { secondary: true }),
        React.createElement("div", { className: "billing-cardlist_footer" },
            React.createElement(pp_react_1.Text, { size: "sm", className: "removeBilling-cardList_text" }, addressToRemove.cardList.length > 1
                ? interpolate_1.default("inHTMLData", addressContent.cards.info, {
                    numberOfCards: addressToRemove.cardList.length,
                })
                : interpolate_1.default("inHTMLData", addressContent.cards.one, {
                    numberOfCards: addressToRemove.cardList.length,
                })),
            commonUtils_1.cardsDetails(addressToRemove.cardList, "removeBilling_card")),
        React.createElement(pp_react_1.Button, { className: "addUpdateButton_space threeby4thWidth", "data-name": addressFpti.billing.noEditOkButton, id: "test_button_ok", onClick: function () { return handleClick(route); } }, commonContent.ok)));
}
var mapStateToProps = function (_a, ownProps) {
    var content = _a.content, route = _a.route, account = _a.account, fpti = _a.fpti;
    var addressData = account.addressData, commonContent = content.common, addressContent = content.addresses, addressFpti = fpti.address, isUpdate = ownProps && ownProps.isUpdate;
    return {
        route: route,
        addressData: addressData,
        commonContent: commonContent,
        addressContent: addressContent,
        addressFpti: addressFpti,
        isUpdate: isUpdate,
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(UpdateBillingMessage);
